import {
  IApplePayPaymentRequest,
  IApplePaySession,
  TApplePayMerchantCapability,
  TApplePaySupportedNetwork,
} from "../types/ApplePay"

const APPLE_PAY_VERSION = 3

// Stone (credenciadora usada pelo checkout) só suporta Visa/Mastercard.
const SUPPORTED_NETWORKS: TApplePaySupportedNetwork[] = ["visa", "masterCard"]
const MERCHANT_CAPABILITIES: TApplePayMerchantCapability[] = ["supports3DS"]

export function isApplePaySupported(): boolean {
  return !!window.ApplePaySession && window.ApplePaySession.canMakePayments()
}

export function buildApplePayPaymentRequest({
  totalLabel,
  totalAmount,
  currencyCode,
  countryCode,
}: {
  totalLabel: string
  totalAmount: string
  currencyCode: string
  countryCode: string
}): IApplePayPaymentRequest {
  return {
    countryCode,
    currencyCode,
    merchantCapabilities: MERCHANT_CAPABILITIES,
    supportedNetworks: SUPPORTED_NETWORKS,
    total: { label: totalLabel, amount: totalAmount },
  }
}

export function createApplePaySession(request: IApplePayPaymentRequest): IApplePaySession {
  if (!window.ApplePaySession) {
    throw new Error("ApplePaySession não disponível neste navegador")
  }
  return new window.ApplePaySession(APPLE_PAY_VERSION, request)
}
